import authReducer from "./slices/authNewSlice";
import customersReducer from "./slices/customers";
import usersSlice from "./slices/usersSlice";
import programsSlice from "./slices/programsSlice";
import servicesSlice from "./slices/servicesSlice";
import formBuilderSlice from "./slices/formBuilder";
import subServicesSlice from "./slices/subServicesSlice";
import clientsSlice from "./slices/clientsSlice";
import ticketsSlice from "./slices/ticketSlice";
import memberBenefitsSlice from "./slices/memberBenefitsSlice";
import membershipPlansSlice from "./slices/membershipPlansSlice";
import commercialsSlice from "./slices/clientsSlice";
import productConfigSlice from "./slices/productConfigSlice";
import blogs from "./slices/blogsSlice";
import vendorListMappingSlice from "./slices/vendorListMappingSlice";
import { combineReducers } from "redux";

const rootReducers = combineReducers({
  auth: authReducer,
  customers: customersReducer,
  users: usersSlice,
  services: servicesSlice,
  programs: programsSlice,
  formBuilder: formBuilderSlice,
  subServices: subServicesSlice,
  clients: clientsSlice,
  tickets: ticketsSlice,
  memberBenefits: memberBenefitsSlice,
  membershipPlans: membershipPlansSlice,
  commercials: commercialsSlice,
  blogs: blogs,
  productConfigSlice:productConfigSlice,
  vendorListMappingSlice:vendorListMappingSlice
});

export default rootReducers;
